import React, { memo } from 'react';
import { sanitizeStringForRegex } from '../../helpers';

interface Props {
    text: string;
    exp: RegExp | undefined;
}

const splitStr = '%^&^%';

export const splitTextToRegex = (searchTerm: string) => {
    const words = sanitizeStringForRegex(searchTerm.trim()).replace(' ', '|');

    return new RegExp(`(${words})`, 'gmi');
};

const HighlightedText = memo<Props>(
    ({ text, exp }) => {
        if (!text || !exp) {
            return <></>;
        }

        const splitArr: string[] = [];

        let changeStr = text;

        let match = exp.exec(changeStr);

        while (match !== null) {
            if (match.index === exp.lastIndex) {
                break;
            }
            changeStr = changeStr.replace(match[0], splitStr);
            splitArr.push(match[0]);

            match = exp.exec(changeStr);
        }

        const stringArr = changeStr.split(splitStr);

        return (
            <>
                {stringArr.map((s, i) => {
                    if (i > 0) {
                        return (
                            <>
                                <mark>{splitArr[i - 1]}</mark>
                                {s}
                            </>
                        );
                    }
                    return s;
                })}
            </>
        );
    },
    (prevProps, nextProps) => {
        if (prevProps.text !== nextProps.text) return false;
        if (prevProps.exp !== nextProps.exp) return false;

        return true;
    }
);

export default HighlightedText;
